/* ============================================================
   landing-empresa.js
   Handler de submit de la landing de la perla (/pages/descubre-cotizada-espanola).
   Replica el submit AJAX del popup (popup-email-perla.liquid) pero, tras la
   captura, redirige al onboarding en vez de mostrar la tesis en la propia página.

   Flujo: validar -> POST /contact (form_type=customer + tags) -> Brevo (externo)
          -> flash "revisa tu email" -> /pages/onboarding?from=perla&perla={handle}
   ============================================================ */
(function () {
  'use strict';

  var CAPTURED_KEY = 'sr_email_captured';
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var form = document.getElementById('le-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var nameInput = form.querySelector('.le-form-section__input--name');
    var emailInput = form.querySelector('.le-form-section__input--email');
    var nameErr = form.querySelector('.le-form-section__error--name');
    var emailErr = form.querySelector('.le-form-section__error--email');
    var submitBtn = form.querySelector('.le-form-section__cta');
    var name = nameInput ? (nameInput.value || '').trim() : '';
    var email = emailInput ? (emailInput.value || '').trim() : '';
    var hasError = false;

    if (nameInput && name.length < 2) {
      nameInput.classList.add('le-form-section__input--error');
      if (nameErr) { nameErr.textContent = 'Escribe tu nombre.'; nameErr.style.display = ''; }
      hasError = true;
    } else if (nameInput) {
      nameInput.classList.remove('le-form-section__input--error');
      if (nameErr) nameErr.style.display = 'none';
    }

    if (!email || !emailRegex.test(email)) {
      emailInput.classList.add('le-form-section__input--error');
      if (emailErr) { emailErr.textContent = 'Revisa el formato: debe ser nombre@dominio.com'; emailErr.style.display = ''; }
      hasError = true;
    } else {
      emailInput.classList.remove('le-form-section__input--error');
      if (emailErr) emailErr.style.display = 'none';
    }

    if (hasError) return;

    var ctaLabel = (submitBtn && submitBtn.textContent) || form.dataset.ctaLabel || 'Enviar';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Enviando...'; }

    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    if (name) fd.append('contact[first_name]', name);
    fd.append('contact[tags]', form.dataset.tags || 'newsletter,landing-empresa');

    var handle = form.dataset.companyHandle || '';
    var redirectUrl = '/pages/onboarding?from=perla&perla=' + encodeURIComponent(handle);

    fetch('/contact#contact_form', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' }
    })
    .then(function () {
      try { localStorage.setItem(CAPTURED_KEY, 'true'); } catch (err) {}

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'lead_captured',
        source: 'landing-perla',
        company: handle,
        page: form.dataset.pageHandle || ''
      });

      /* Flash "revisa tu email" antes del redirect (no perdemos el tracking). */
      var pre = document.getElementById('le-pre-submit');
      var post = document.getElementById('le-post-submit');
      if (pre) pre.style.display = 'none';
      if (post) post.style.display = '';

      window.setTimeout(function () {
        window.location.assign(redirectUrl);
      }, 900);
    })
    .catch(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = ctaLabel; }
      if (emailInput) emailInput.classList.add('le-form-section__input--error');
      if (emailErr) { emailErr.textContent = 'Algo no ha ido bien. Inténtalo de nuevo.'; emailErr.style.display = ''; }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'landing_perla_error', error_type: 'server' });
    });
  });
})();
